<template>
    <div class="banner banner-danger">
        <slot />
    </div>
</template>
